// extracted by mini-css-extract-plugin
export default {"actions":"sign-up-actions_actions__ahVCh"};